import { useSettlePolling } from '../hooks/useSettlePolling'
import { CHECKOUT_TAB_POLL_MS } from './CheckoutTabWait'
import { ClockIcon } from './icons'

export interface PaymentProcessingWaitProps {
  /**
   * Asks whether the payment has settled. Resolves true once it has (the
   * widget has moved on) and false to keep waiting.
   */
  poll: () => Promise<boolean>
  /** How often to ask while the widget is in view. */
  intervalMs?: number
}

/**
 * Shown when the customer paid with Klarna and Stripe has not confirmed the
 * money yet (ACA-105). The time stays held meanwhile, so there is nothing to
 * choose: the widget asks every few seconds and moves on once Stripe answers.
 */
export function PaymentProcessingWait({
  poll,
  intervalMs = CHECKOUT_TAB_POLL_MS,
}: PaymentProcessingWaitProps) {
  useSettlePolling(poll, intervalMs)

  return (
    <div className="ac-confirmation" role="status">
      <div className="ac-confirmation__badge" aria-hidden="true">
        <ClockIcon size={30} />
      </div>

      <div className="ac-stack ac-stack--tight">
        <h3 className="ac-heading ac-heading--display">Confirming your payment</h3>
        <p className="ac-prose">
          Klarna is confirming your payment. This usually takes a moment, and your time is held
          until it's done. Your booking will show here as soon as it is.
        </p>
      </div>

      <span className="ac-spinner" aria-hidden="true" />
    </div>
  )
}
